import React from 'react';
import { useProgress } from '../contexts/ProgressContext';
import './ProgressBar.css';

const ProgressBar = ({ moduleId, showLabel = true, size = 'medium' }) => {
  const { progress, getModuleProgress } = useProgress();

  const percentage = moduleId
    ? getModuleProgress(moduleId)
    : progress.totalProgress;

  const getProgressColor = (pct) => {
    if (pct >= 100) return '#10b981'; // Green
    if (pct >= 70) return '#f59e0b'; // Orange
    if (pct >= 30) return '#3b82f6'; // Blue
    return '#6b7280'; // Gray
  };

  return (
    <div className={`progress-bar-container ${size}`}>
      {showLabel && (
        <div className="progress-label">
          <span className="progress-text">
            {moduleId ? `Module ${moduleId}` : 'Progression totale'}
          </span>
          <span className="progress-percentage">{percentage}%</span>
        </div>
      )}
      <div className="progress-track">
        <div
          className="progress-fill"
          style={{
            width: `${percentage}%`,
            backgroundColor: getProgressColor(percentage)
          }}
        >
          {percentage >= 100 && <span className="progress-check">✓</span>}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
